import Welcome from "./components/Welcome";
import Button from "components/ui/Button";
import ArrowLeft from "images/arrow_left.svg?react";
import MainLogoIcon from "images/main-logo.svg?react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";
import CreateAccount from "./components/CreateAccount";
import FrameBack from "images/frame_back.svg?react";
import { useLocation, useNavigate } from "react-router-dom";
import AppLanguageSwitcher from "../../components/AppLanguageSwitcher";
import { routes } from "pages/routes";

const STEP = {
  welcome: 1,
  createAccount: 2,
};

function SignUpByInvitation() {
  const { t } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [step, setStep] = useState(params.get("consumer") === "true" ? 2 : 1);
  const navigate = useNavigate();

  const handlePreviousStep = () => {
    if (step !== STEP.welcome) {
      setStep(prev => prev - 1);
    }
  };

  const handleNextStep = () => {
    if (step === STEP.welcome) {
      setStep(STEP.createAccount);
    } else {
      navigate(routes.root.path());
    }
  };

  return (
    <div className={"sign-up-by-invitation-page"}>
      <div className={"sign-up-by-invitation container"}>
        <div className="header">
          <Button
            variant="plain"
            className={"previous-step"}
            Icon={ArrowLeft}
            aria-label={t("Common.actions.back")}
            onClick={handlePreviousStep}
            // Hidden rather than unmounted so the logo stays centred;
            // visibility:hidden also takes it out of the tab order.
            style={{
              visibility: step !== STEP.welcome ? "visible" : "hidden",
            }}
          />
          <MainLogoIcon className="signup-logo" />
          <AppLanguageSwitcher color={"black"} className={"language-btn"} />
        </div>

        <div className="progress-bar">
          <div className="progress-inner" />
        </div>

        {step === STEP.welcome && (
          <Welcome tm={params.get("tm")} onNextStep={handleNextStep} />
        )}

        {step === STEP.createAccount && <CreateAccount onNextStep={handleNextStep} />}
      </div>

      {step === STEP.welcome && <FrameBack className="frame-back" />}
    </div>
  );
}

export default SignUpByInvitation;
